import type { FeatureDiscoveryFeatures } from '@core/feature-discovery-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<FeatureDiscoveryFeatures | null>()('feature-discovery');

const { update, updateSuccess, updateFailed } = actions;
const FeatureDiscoveryActions = { update, updateSuccess, updateFailed };

export {
  FeatureDiscoveryActions,
  selectors as FeatureDiscoverySelectors,
  reducer as FeatureDiscoveryReducer,
  namespace as FeatureDiscoveryNamespace,
};
